export default "__VITE_ASSET__BmPjBb$___"